import React, { useCallback, useState } from 'react';
import { FontStyles } from './FontStyles';
import { ToggleActiveButton } from './ToggleActiveButton';
import { getErrorMessage } from '../../../../../get-error-message';
import { WidgetMaker } from '../../../../../types/widget-maker';
import { CampaignDraft } from '../../../../../types/campaign-draft';
import { ParseJoiValidateResponse } from '../../../../../../../utils';
import { SectionStyled, TextBoxStyled } from './EmailDisplaySettingsSection.styles';

interface HeaderSectionProps {
  widgetMaker: Partial<WidgetMaker>;
  onChange: (campaign: CampaignDraft) => void;
  errors: ParseJoiValidateResponse<WidgetMaker>;
}

export const HeaderSection = ({ widgetMaker, onChange, errors }: HeaderSectionProps) => {
  const headerConfig = widgetMaker?.header;

  const [isActive, setIsActive] = useState<boolean>(headerConfig?.active);

  const handleHeaderChange = useCallback(
    (field, value) => {
      onChange({
        widgetMaker: {
          ...widgetMaker,
          header: {
            ...headerConfig,
            [field]: value,
          },
        },
      });
    },
    [onChange, widgetMaker]
  );

  const onToggleClick = useCallback(() => {
    setIsActive(!isActive);
    handleHeaderChange('active', !isActive);
  }, [setIsActive, handleHeaderChange]);

  return (
    <SectionStyled>
      {isActive ? (
        <>
          <TextBoxStyled
            label='Title Text'
            placeholder='type...'
            value={headerConfig?.text || ''}
            onChange={value => handleHeaderChange('text', value)}
          />
          <FontStyles
            config={headerConfig}
            onChange={handleHeaderChange}
            getErrorMessage={fieldKey => getErrorMessage(errors, 'header', fieldKey)}
          />
          <ToggleActiveButton onToggleClick={onToggleClick} isActive={isActive} title='header' />
        </>
      ) : (
        <ToggleActiveButton onToggleClick={onToggleClick} isActive={isActive} title='header' />
      )}
    </SectionStyled>
  );
};
